"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameSpaceKeyStarknet = exports.NameSpaceKeyTron = exports.NameSpaceKeyCosmos = exports.NameSpaceKeyAptos = exports.NameSpaceKeyBtc = exports.NameSpaceKeySui = exports.NameSpaceKeyTON = exports.NameSpaceKeySOL = exports.NameSpaceKeyEip155 = void 0;
exports.NameSpaceKeyEip155 = "eip155";
exports.NameSpaceKeySOL = "solana";
exports.NameSpaceKeyTON = "ton";
exports.NameSpaceKeySui = "sui";
exports.NameSpaceKeyBtc = "btc";
exports.NameSpaceKeyAptos = "aptos";
exports.NameSpaceKeyCosmos = "cosmos";
exports.NameSpaceKeyTron = "tron";
exports.NameSpaceKeyStarknet = "starknet";
